import { Navigate, Outlet, useLocation } from 'react-router-dom'
import { AppShell, Box, useMantineTheme } from '@mantine/core'
import { useDisclosure } from '@mantine/hooks'

import { NavigationBar } from '@/layouts/AuthenticatedLayout/components/NavigationBar/NavigationBar'
import { Topbar } from '@/layouts/AuthenticatedLayout/components/Topbar/Topbar'

import { LoginRoutePathsEnum } from '@/modules/login/routes/loginRouteConfig.types'
import { OnboardingRoutePathsEnum } from '@/modules/onboarding/routes/onboardingRouteConfig.types'

import { useUserStore } from '@/store/user.store'

import { role } from '@/__generated__/requests'

export function AuthenticatedLayout() {
  const user = useUserStore.use.user()
  const isInitialized = useUserStore.use.isInitialized()

  const location = useLocation()
  const theme = useMantineTheme()
  const [opened, { toggle }] = useDisclosure()

  if (!isInitialized) {
    return null
  }

  if (!user) {
    return (
      <Navigate state={{ from: location }} to={LoginRoutePathsEnum.LOGIN} />
    )
  }

  if (user.roles?.includes(role.EMPLOYEE) && !user.isOnboarded) {
    return (
      <Navigate
        state={{ from: location }}
        to={OnboardingRoutePathsEnum.ONBOARDING}
      />
    )
  }

  return (
    <AppShell
      navbar={{
        breakpoint: 'sm',
        collapsed: { mobile: !opened },
        width: 264,
      }}
    >
      <AppShell.Navbar bg={theme.other.colors.purple} withBorder={false}>
        <NavigationBar opened={opened} toggle={toggle} />
      </AppShell.Navbar>

      <AppShell.Main bg={theme.other.colors.bgMain}>
        <Topbar opened={opened} toggle={toggle} />
        <Box p={24}>
          <Outlet />
        </Box>
      </AppShell.Main>
    </AppShell>
  )
}
